<template>
    <DCardBody class="p-3 mb-2 bg-warning text-white">
        {{ __('settings.idn_character_sets.hint') }}
    </DCardBody>
    <DCard
        padding
    >
        <DTable
            :items="idnCharacterSets"
            :fields="[
                {key: 'name', label: __('settings.idn_character_sets.table.headers.name')},
                {key: 'characters', label: __('settings.idn_character_sets.table.headers.characters')},
                {key: 'description', label: __('settings.idn_character_sets.table.headers.description')},
                {key: 'actions', label: '',_style: { minWidth: '5%' }}
            ]"
            hover
        >
            <template #name="{item}">
                <td>
                    {{ item.name }}
                </td>
            </template>
            <template #characters="{item}">
                <td class="text-break">
                    {{ item.characters }}
                </td>
            </template>
            <template #description="{item}">
                <td>
                    {{ item.description }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.name}`"
                            mini
                            icon="pencil"
                            @click="editCharacterSet(item.id)"
                        />
                        <DButton
                            :id="`btn-delete-${item.name}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            @click="deleteCharacterSet(item.id, item.name)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.idn_character_sets.buttons.add')"
                @click="createCharacterSet"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.idn_character_sets.modal.header')"
            :message="__('settings.idn_character_sets.modal.text',{name: characterSetNameToDelete})"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script setup>
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const showConfirmationModal = ref(false)
const characterSetNameToDelete = ref('')
const characterSetId = ref('')

defineProps({
    idnCharacterSets: {
        type: Array,
        default: () => {
            return []
        }
    }
})
function editCharacterSet (id) {
    return router.get(route('settings.idn-character-sets.edit', { idn_character_set: id }))
}
function deleteCharacterSet (id, name) {
    showConfirmationModal.value = true
    characterSetNameToDelete.value = name
    characterSetId.value = id
}
function deleteCallBack () {
    showConfirmationModal.value = false
    router.delete(route('settings.idn-character-sets.destroy', { idn_character_set: characterSetId.value }))
}
function createCharacterSet () {
    return router.get(route('settings.idn-character-sets.create'))
}
</script>
